import {
  isWxMiniProgram,
  callApp,
  isIOS,
  getUrlParam,
  isLtlMiniProgram,
  isJdMiniProgram,
  isAlipayMiniUa,
  isMoveMini,
  isBaiduBoxUa,
  isQuickAppUa,
  isHllApp,
  isXlMiniProgram
} from '@/utils';
import { isXlUserApp } from '@/utils/judgeEnv';

const PREFIX = location.host.match(/-(\w)+/g) || '';

// 通用券 大货车券 小B货运券
const handlerDefault = (lanuchType = '14') => {
  console.log('handlerDefault');
  isWxMiniProgram() //小程序
    ? wx.miniProgram.reLaunch({
        url: isMoveMini()
          ? '/pages/index/index'
          : '/pages/home/index' +
            `${lanuchType == 12 ? '?from=big_truck_service' : ''}`
      })
    : isAlipayMiniUa() //支付宝小程序
    ? my.reLaunch({
        url: '/pages/index/index'
      })
    : isBaiduBoxUa() //百度小程序
    ? swan.webView.navigateTo({
        url: '/pages/home/index'
      })
    : isJdMiniProgram()
    ? jd.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    : isQuickAppUa() //快应用
    ? system.go('/pages/home/index')
    : (location.href = 'https://m.huolala.cn'); //浏览器
};

//搬家券
const handlerMovition = () => {
  console.log(isAlipayMiniUa(), 'isAlipayMiniUa');
  let token = getUrlParam('token') || getUrlParam('_token');
  if (isMoveMini()) {
    wx.miniProgram.reLaunch({
      url: '/pages/index/index'
    });
  } else if (isAlipayMiniUa()) {
    my.reLaunch({
      url: '/pages/index/index'
    });
  } else if (isJdMiniProgram()) {
    jd.miniProgram.reLaunch({
      url: '/pages/index/index'
    });
  } else {
    location.href = `https://banjia${PREFIX}.huolala.cn/#/?sso=1${
      token ? '&token=' + token : ''
    }`;
  }
};
//零担物流
const handlerLogistics = () => {
  if (isLtlMiniProgram()) {
    wx.miniProgram.reLaunch({
      url: '/pages/index'
    });
  } else {
    location.href = `https://ltl${PREFIX}.huolala.cn/index.html#/?channel=actchoujiang`;
  }
};

// 小拉
const handlerXlWxa = () => {
  if (isXlMiniProgram()) {
    wx.miniProgram.reLaunch({
      url: '/pages/index/index'
    });
  } else {
    location.href = 'weixin://dl/business/?t=2OXSSbYXeHu';
    return;
  }
};

export const useCouponNew = (business_type = 1) => {
  if (isHllApp()) {
    callApp(JSON.stringify({ action: 'useCoupon', business_type }));
    return;
  }
  switch (+business_type) {
    case 1:
      return handlerDefault('14'); //14 小b 、12 大货车
    case 2:
      return handlerMovition();
    case 3:
      return handlerDefault('12');
    case 4:
      return handlerDefault('14');
    case 5:
      return handlerLogistics();
    case 8:
      return handlerXlWxa();
  }
};
/**
 * app端内券使用跳转
 * @param {string} launch lanuchType
 * @param {number} business_type 券业务类型
 * @param {boolean} requireApp 强制走app方法
 */
const appCouponUse = (launch, business_type, requireApp) => {
  let appVer = getUrlParam('version');
  return new Promise((res, rej) => {
    if (isHllApp() || requireApp) {
      if (appVer && Number(appVer.replace(/\./g, '')) < 6480 && isIOS()) {
        return (location.href = `hlluapp://jumpto_${launch}`);
      }
      if (isXlUserApp()) {
        return my.reLaunch({
          url: '/pages/index/index'
        });
      }
      try {
        callApp(
          JSON.stringify({
            action: 'useCoupon',
            business_type: business_type
          })
        );
      } catch {
        res(true);
        return;
      }
      rej(false);
    } else {
      res(true);
    }
  });
};
/**
 * 其他端内券使用跳转
 * @param {string} launch lanuchType
 * @param {number} business_type 券业务类型
 */
const otherHandle = (launch, business_type) => {
  switch (+business_type) {
    case 1:
      return handlerDefault(launch); //14 小b 、12 大货车
    case 2:
      return handlerMovition();
    case 3:
      return handlerDefault(launch);
    case 4:
      return handlerDefault(launch);
    case 5:
      return handlerLogistics();
    case 8:
      return handlerXlWxa();
  }
};
/**
 * 券使用方法
 * @param {number} business_type 业务类型：1-通用券，2-搬家券，3-大货车券，4-小B货运券，5-零担物流 8-小拉
 * @param {boolean} requireApp 强制走app方法
 */
export const useCoupon = async (business_type = 1, requireApp = false) => {
  let launch = '14';
  switch (+business_type) {
    case 1:
      launch = '14'; //14 小b 、12 大货车
      break;
    case 2:
      launch = '15'; //14 小b 、12 大货车
      break;
    case 3:
      launch = '12'; //14 小b 、12 大货车
      break;
    case 4:
      launch = '14'; //14 小b 、12 大货车
      break;
    case 5:
      launch = '13'; //14 小b 、12 大货车
      break;
  }
  await appCouponUse(launch, business_type, requireApp);
  otherHandle(launch, business_type);
};
